import { z } from 'zod'

export const primaryNeedZod = z.object({
	primaryNeed: z.string().min(2),
})

export const questionZod = z.object({
	question: z.string().min(2),
})

export const personalIssueZod = z.object({
	personalIssue: z.string().min(2),
})
export const personalIssueOtherZod = z.object({
	personalIssueOther: z.string().optional(),
})

export const issueRelationZod = z.object({
	issueRelation: z.string().min(2),
})
export const issueRelationOtherZod = z.object({
	issueRelationOther: z.string().optional(),
})
export const relationshipChallengeZod = z.object({
	relationshipChallenge: z.string().min(2),
})
export const relationshipChallengeOtherZod = z.object({
	relationshipChallengeOther: z.string().optional(),
})

export const communicationContextZod = z.object({
	communicationContext: z.string().min(2),
})
export const communicationContextOtherZod = z.object({
	communicationContextOther: z.string().optional(),
})

export type PrimaryNeed = z.infer<typeof primaryNeedZod>
export type PersonalIssue = z.infer<typeof personalIssueZod>
export type Question = z.infer<typeof questionZod>
export type PersonalIssueOther = z.infer<typeof personalIssueOtherZod>
export type IssueRelation = z.infer<typeof issueRelationZod>
export type IssueRelationOther = z.infer<typeof issueRelationOtherZod>
export type RelationshipChallenge = z.infer<typeof relationshipChallengeZod>
export type RelationshipChallengeOther = z.infer<
	typeof relationshipChallengeOtherZod
>
export type CommunicationContext = z.infer<typeof communicationContextZod>
export type CommunicationContextOther = z.infer<
	typeof communicationContextOtherZod
>

export type SessionForm = PrimaryNeed &
	PersonalIssue &
	PersonalIssueOther &
	IssueRelation &
	IssueRelationOther &
	RelationshipChallenge &
	RelationshipChallengeOther &
	CommunicationContext &
	CommunicationContextOther &
	Question
